var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-row',{staticClass:"my-2"},[_c('v-col',[_c('div',{staticClass:"text-body-1"})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }